'use strict';

import React from 'react';
require('styles/Product.scss');

class ProductComponent extends React.Component {
  render() {
    let {product} = this.props;
    return (
      /*
      <div className="product-component">
        <span className="related-product">相关推荐：</span>
        <a href={product.url}>
          <div className="product">
            <div className="cover">
              <img src={product.cover.small} />
            </div>
            <div className="title">
              <span className="price">¥{product.price}</span> ─ {product.title}
            </div>
          </div>
        </a>
      </div> */

      <div className="bg-white product-component">
      {/* <p className="fz-12">行程推荐</p> */}
      {/* <div className="bottom"></div> */}
        <a href={product.url}>
          <div className="product">
            <div className="cover">
              <img src={product.cover.big.replace('!li750','')} />
              <span className="price">¥{product.price} 起</span>
            </div>
            <div className="title fz-14 mt-15">
              <span style={{fontWeight:'500',color:'#607fa6'}}>行程推荐：</span>{product.title}
            </div>
          </div>
        </a>
      </div>
    );
  }
}

ProductComponent.displayName = 'ProductComponent';

// Uncomment properties you need
// BackComponent.propTypes = {};
// BackComponent.defaultProps = {};

export default ProductComponent;



// WEBPACK FOOTER //
// ./src/components/ProductComponent.js